import { render, staticRenderFns } from "./NasDesk.vue?vue&type=template&id=019028e6&scoped=true"
import script from "./NasDesk.vue?vue&type=script&lang=js"
export * from "./NasDesk.vue?vue&type=script&lang=js"
import style0 from "./NasDesk.vue?vue&type=style&index=0&id=019028e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019028e6",
  null
  
)

export default component.exports